export default __webpack_public_path__ + "static/media/c008-2.3f4677b3.png";